// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1NPBu","image":"App_image__2PlT2"};